"use strict";
APP.game.CageObject = function (p_type) {

    // Invoke (needed)
    EHDI.aka.Container.call(this);

    // Properties

    // ** Parent (This reference)
    var _parent = this;

    // ** General Values
    var _type;

    // ** Graphics
    var _grpHit, _sprCage;
    var _glow;

    // Private Methods

    // ** Handlers

    /**
     * Handler for frame update
     * @param {Number} p_delta 
     */
    var _handler_frameUpdate = function (p_delta) {

        if (APP.game.btnPause) {

            if (APP.game.btnPause.isPaused === true) return;
        }
        // Do something here

        if (_glow)
            _glow.update(p_delta);
    };

    this.glow = function () {
        if (!_glow) return;

        _glow.appear();
        _glow.visible = true;
    }

    this.glowFade = function () {
        if (!_glow) return;

        _glow.disappear();
        _glow.visible = false;
    }

    this.disableGlow = function () {
        if (!_glow) return;
        this.glowFade();
        _glow = null;
        _parent.removeChild(_glow);
    }


    /**
     * Handler for animal drag start.
     * @param {Event} e The corresponding event. 
     */
    var _handlerAnimal_dragStart = function (e) {

        // Check if event values are valid
        if (!e) return;
        if (!e.obj) return;
    };

    /**
     * Handler for animal drag end.
     * @param {Event} e The corresponding event. 
     */
    var _handlerAnimal_dragEnd = function (e) {
        // Check if event values are valid
        if (!e) return;
        if (!e.obj) return;
    };

    /**
     * Handler for animal drag end.
     * @param {Event} e The corresponding event. 
     */
    var _handlerAnimal_updatedState = function (e) {
        // Check if event values are valid
        if (!e) return;
        if (!e.obj) return;
    };


    // ** Initialization Methods

    var _initProps = function (p_type) {

        // Check if param value if not valid, then throw errpr
        if (p_type !== APP.game.AnimalType.SHEEP &&
            p_type !== APP.game.AnimalType.GOAT) throw "Type value for cage is invalid.";

        // Initialize properties
        _type = p_type;
    };

    var _initGraphics = function () {

        // Initialize graphics
        if (!_sprCage) {

            _sprCage = new EHDI.aka.Sprite(EHDI.Assets.images["assets/game/img_ground_overlay.png"]);
            _sprCage.anchor.set(0.5, 1);

            if (_parent) _parent.addChild(_sprCage);
        }

        if (!_glow) {
            _glow = new EHDI.components.GlowEffect(216);
            _glow.y = _sprCage.height * -0.5;
            _glow.visible = false;


            if (_parent) _parent.addChild(_glow);
        }

        if (!_grpHit) {

            // Draw graphics
            _grpHit = new EHDI.aka.Graphics();
            _grpHit.clear();

            _grpHit.beginFill(0x00FF00);
            // Rectangle within the ellipse
            // Rectangle width = Ellipse width / Math.sqrt( 2 ) 
            // Rectangle height = Ellipse height / Math.sqrt( 2 )
            // _grpHit.drawRect( 0, 0, _sprCage.width / Math.sqrt( 2 ), _sprCage.height / Math.sqrt( 2 ) );
            _grpHit.drawRect(0, 0, _sprCage.width, _sprCage.height);
            _grpHit.endFill();

            _grpHit.x = -(_grpHit.width * 0.5);
            _grpHit.y = -(_grpHit.height * 0.5) - (_sprCage.height * 0.5);

            _grpHit.alpha = 0.5;

            if (APP.game.debugEnabled === true) _grpHit.visible = true;
            else _grpHit.visible = false;

            if (_parent) _parent.addChild(_grpHit);
        }
    };

    var _initListeners = function () {

        // Add frame listeners
        APP.managers.update.addFrameListener(_handler_frameUpdate);

        // Add satelite listeners
        APP.managers.event.addListener(APP.game.AnimalEvent.DRAG_START, _handlerAnimal_dragStart);
        APP.managers.event.addListener(APP.game.AnimalEvent.DRAG_END, _handlerAnimal_dragEnd);
        APP.managers.event.addListener(APP.game.AnimalEvent.UPDATED_STATE, _handlerAnimal_updatedState);
    };

    // ** Kill Methods

    var _killProps = function () {

        _parent = null;
        _type = null;
    };

    var _killGraphics = function () {

        if (_sprCage) {

            if (_sprCage.parent) _sprCage.parent.removeChild(_sprCage);

            _sprCage.destroy({ children: true });
        }
        _sprCage = null;

        if (_grpHit) {

            _grpHit.clear();
            if (_grpHit.parent) _grpHit.parent.removeChild(_grpHit);

            _grpHit.destroy({ children: true });
        }
        _grpHit = null;
    };

    var _killListeners = function () {

        // Remove frame listeners
        APP.managers.update.removeFrameListener(_handler_frameUpdate);

        // Add satelite listeners
        APP.managers.event.removeListener(APP.game.AnimalEvent.DRAG_START, _handlerAnimal_dragStart);
        APP.managers.event.removeListener(APP.game.AnimalEvent.DRAG_END, _handlerAnimal_dragEnd);
        APP.managers.event.removeListener(APP.game.AnimalEvent.UPDATED_STATE, _handlerAnimal_updatedState);
    };

    // Public Methods

    this.destroy = function () {

        // Kill listeners
        _killListeners();

        // Kill graphics
        _killGraphics();

        // Kill props
        _killProps();

        // Call superclass method
        APP.game.CageObject.prototype.destroy.apply(this, arguments);
    };

    // Call init methods
    _initProps(p_type);
    _initGraphics();
    _initListeners();

    Object.defineProperties(_parent, {
        "hit": {
            get: function () { return _grpHit; },
            enumerable: true
        },
        "type": {
            get: function () { return _type; },
            enumerable: true
        },
    });

    // Return
    return _parent;
};

APP.game.CageObject.prototype = Object.create(EHDI.aka.Container.prototype);
APP.game.CageObject.prototype.constructor = APP.game.CageObject;
